import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

import {
  Sgkd034aResponse,
  Sgkd034aResponseClmtoAddrInfo
} from 'sg-api';

@Component({
  selector: 'app-sgkd002d-basic',
  templateUrl: './sgkd002d-basic.component.html',
  styleUrl: './sgkd002d-basic.component.scss'
})
export class Sgkd002dBasicComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  @Input() mainForm: UntypedFormGroup;
  /** 請求お客さま番号 */
  @Input() paramClaimCtrNo: string;
  /** 住所情報・お客さま氏名取得APIレスポンス */
  @Input() sgkd034aResponse: Sgkd034aResponse;
  /** 情報アイコンクリックイベント */
  @Output() infoClick = new EventEmitter<void>();

  constructor() {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd002dBasicComponent
   */
  ngOnInit(): void {
    
    let seikyuInfo = this.sgkd034aResponse.responseDto.clmtoAddrInfo;

    this.mainForm.addControl('claimCtrNo', 
      new UntypedFormControl({ value: this.paramClaimCtrNo, disabled: true }, Validators.required));
    this.mainForm.addControl('visitName',
      new UntypedFormControl({ value: seikyuInfo.visitName, disabled: true }, Validators.required));
    this.mainForm.addControl('addr',
      new UntypedFormControl({ value: this.formatAddress(seikyuInfo), disabled: true }, Validators.required));
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd002dBasicComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * 情報アイコンクリックイベントの親コンポーネント伝達
   * 
   * @memberof Sgkd002dBasicComponent
   */
  onClickIcon() {
    this.infoClick.emit();
  }

  /**
   * 請求先住所フォーマット
   * 
   * @param seikyuInfo 請求先住所情報
   * @returns - 請求先住所
   * @memberof Sgkd002dBasicComponent
   */
  private formatAddress(seikyuInfo: Sgkd034aResponseClmtoAddrInfo): string {

    let address = "";
    address += seikyuInfo.prefectureaname ?? "";
    address += seikyuInfo.administrativecitywardname ?? "";
    address += seikyuInfo.choname ?? "";
    address += seikyuInfo.chome ?? "";
    address += seikyuInfo.buildingnumber ?? "";
    address += seikyuInfo.visitSupadrAname ?? "";
    address += seikyuInfo.visitYagouAname ?? "";

    return address;
  }
}
